<div>
  <div class="strong-text">{{ uiService.productName }} is not authorized to access this resource on your behalf.</div>
  <div>
    To address this, either add the role in the message below to {{ viewableIssue.resourceName }}'s policy to grant
    {{ uiService.productName }} access, or remove this resource from your {{ uiService.productName }} application.
  </div>
  <div class="padding-top">
    Original error message: <span class="code small">{{ issue.message }}</span>
  </div>
</div>
